import styled from 'styled-components'

interface IProps {
    color: string
}

export const AlarmCardContainer = styled.div<IProps>`
    width: 450px;
    cursor: pointer;
    border-left: 8px solid ${({ color }) => color};
    border-top: 1px solid var(--gray-400);
    border-right: 1px solid var(--gray-400);
    border-bottom: 1px solid var(--gray-400);
    border-radius: 4px;
    padding: 8px 14px 8px 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: relative;

    &:hover {
        background: var(--blue-200);
    }

    .alarm-card {
        display: flex;

        &.first-row {
            justify-content: space-between;

            .first-row-spans {
                display: flex;
                gap: 3px;
                flex-direction: column;
                > span {
                    font-size: 13px;
                }
                .entity-span {
                    color: var(--gray-800);
                    font-weight: 600;
                    text-transform: capitalize;
                }

                .had-a-span {
                    color: var(--gray-600);
                    font-weight: 400;
                }

                .colored-span {
                    color: var(--blue-500);
                    font-weight: 600;
                }
            }

            .fa-ellipsis-v {
                color: var(--blue-500);
                font-size: 15px;
                cursor: pointer;
                width: 24px;
                height: 24px;
                text-align: right;
            }
        }

        &.second-row {
            display: flex;
            align-items: center;
            gap: 8px;
            .second-row-spans {
                display: flex;
                gap: 3px;
                > span {
                    font-size: 11px;
                    color: var(--gray-700);
                    font-weight: 400;
                }

                .time-span {
                    font-weight: 600;
                }
                .notified-group {
                    font-weight: 600;
                }
            }
        }

        &.third-row {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-top: -8px;
            .second-row-spans {
                display: flex;
                gap: 3px;
                > span {
                    font-size: 11px;
                    color: var(--gray-700);
                    font-weight: 400;
                }

                .time-span {
                    font-weight: 600;
                }
                .notified-group {
                    font-weight: 600;
                }
            }
        }
    }
`

export const DiagramSelectedView = styled.div<{ color: string }>`
    position: absolute;
    right: 16px;
    top: 23px;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    background-color: ${({ color }) => color};
    width: 135px;
    display: flex;
    justify-content: center;
    padding: 8px 0;
    gap: 8px;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
`

export const BowtieSelectedView = styled.div`
    position: absolute;
    right: 127px;
    top: 32px;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    background-color: ${({ theme }) => theme['gray-0']};
    width: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
    gap: 8px;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    z-index: 3;

    .bowtie-diagram-view {
        width: 100%;
        height: 100%;
        padding: 8px;
        &:hover {
            background-color: ${({ theme }) => theme['blue-200']};
        }
    }
`
